import { Tooltip } from 'antd';
import { useFocusMode, useSetFocusMode } from 'hooks/useFocusMode';
import { Shrink } from 'lucide-react';
import { createPortal } from 'react-dom';
import { useTranslate } from '@tolgee/react';
import { useEffect, useRef, useState } from 'react';
import { focusModeGuideToastCache } from 'services/cache';
import { useUnmount } from 'ahooks';

const FocusModeExitButton = () => {
  const setFocusMode = useSetFocusMode();
  const { t } = useTranslate();
  const ref = useRef<string | null>(focusModeGuideToastCache.get<string>());
  const [visible, setVisible] = useState(ref.current ? false : true);

  const title = ref.current
    ? t('app.config.focusMode.close.tips')
    : t('app.config.focusMode.guideToast');

  useEffect(() => {
    if (visible) {
      const timer = setTimeout(() => {
        setVisible(false);
        focusModeGuideToastCache.set('1');
        ref.current = '1';
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [visible]);

  useUnmount(() => {
    focusModeGuideToastCache.set('1');
  });

  return createPortal(
    <div className="absolute top-0 right-0 z-[9999]">
      <Tooltip visible={visible} onVisibleChange={setVisible} title={title} placement="left">
        <div
          className="cursor-pointer w-[32px] h-[32px] flex items-center justify-center bg-[#232426] opacity-50 text-[#FFFFFF] rounded-bl-[12px]"
          onClick={() => setFocusMode(false)}
        >
          <Shrink size={16} />
        </div>
      </Tooltip>
    </div>,
    document.body,
  );
};

export const FocusModeExit = () => {
  const isFocusMode = useFocusMode();

  if (isFocusMode) {
    return <FocusModeExitButton />;
  }

  return null;
};
